import {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';

import subscriptionHOC from '@drivesally/sally-fw/lib/event/hoc/subscription.hoc.event';

import listTicketsApi from '../../api/listTickets.api.crm';
import {set as setAction} from '../../redux/actions';
import conversationMessageEvent from '../../events/conversationMessage.event.crm';
import ticketClosedEvent from '../../events/ticketClosed.event.crm';
import ticketCreatedEvent from '../../events/ticketCreated.event.crm';
import ticketUpdatedEvent from '../../events/ticketUpdated.event.crm';

import wait from '../../../libs/wait';

class OpenCrmTicketsCountContainer extends Component {
  static propTypes = {
    dispatch: PropTypes.func,
    subscribe: PropTypes.func,
  };

  componentDidMount() {
    this.mounted = true;
    this.fetchCount();
    this.poll();
    this.props.subscribe(
      ticketUpdatedEvent.subscribe(this.fetchCount),
      ticketCreatedEvent.subscribe(this.fetchCount),
      ticketClosedEvent.subscribe(this.fetchCount),
      conversationMessageEvent.subscribe(this.fetchCount)
    );
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  fetchCount = async () => {
    const {dispatch} = this.props;
    try {
      const {count} = await listTicketsApi({
        state: 'open',
        limit: 1,
      });
      if (!this.mounted) return;
      dispatch(setAction({openTicketsCount: count}));
    } catch (error) {
      // do nothing
    }
  };

  poll = async () => {
    await wait(30000);
    if (!this.mounted) return;
    await this.fetchCount();
    this.poll();
  };

  render() {
    return null;
  }
}

export default subscriptionHOC(connect()(OpenCrmTicketsCountContainer));
